import { render, staticRenderFns } from "./GJgrowEventCreateFormFormat.vue?vue&type=template&id=6714bd72&scoped=true&"
import script from "./GJgrowEventCreateFormFormat.vue?vue&type=script&lang=ts&"
export * from "./GJgrowEventCreateFormFormat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6714bd72",
  null
  
)

export default component.exports